import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useFormik } from "formik";

interface NewUserModalFormProps {
  buttonLabel: string;
  UserValidationSchema: any;
  onCreateNewUser: (userDetails: any) => void;
}

const NewUserModalForm: React.FC<NewUserModalFormProps> = ({
  buttonLabel,
  UserValidationSchema,
  onCreateNewUser,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      countryCode: '+91',
      mobile: '',
      password: '',
      confirmPassword: '',
    },
    validationSchema: UserValidationSchema,
    onSubmit: (values, { resetForm }) => {
      const newValues = {
        ...values,
        mobile: values.mobile.toString(),
      };
      
      onCreateNewUser(newValues);
      resetForm();
      handleModalClose();
    },
  });

  return (<>
    <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
      {buttonLabel}
    </Button>
    <Modal show={showModal} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>{buttonLabel}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="full-name">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              onChange={formik.handleChange}
              isInvalid={!!(formik.touched.firstName && formik.errors.firstName)}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.firstName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="full-name">
            <Form.Label>Middle Name</Form.Label>
            <Form.Control
              type="text"
              name="middleName"
              onChange={formik.handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="full-name">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              onChange={formik.handleChange}
              isInvalid={!!(formik.touched.lastName && formik.errors.lastName)}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.lastName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              onChange={formik.handleChange}
              isInvalid={!!(formik.touched.email && formik.errors.email)}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.email}
            </Form.Control.Feedback>
          </Form.Group>
          <Row>
            <Col sm="4">
              <Form.Group className="mb-3" controlId="country-code">
                <Form.Label>Country Code</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  name="countryCode"
                  value="+91"
                  onChange={formik.handleChange}
                  isInvalid={!!(formik.touched.countryCode && formik.errors.countryCode)}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.countryCode}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col sm="8">
              <Form.Group className="mb-3" controlId="mobile">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="text"
                  name="mobile"
                  onChange={formik.handleChange}
                  isInvalid={!!(formik.touched.mobile && formik.errors.mobile)}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.mobile}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              onChange={formik.handleChange}
              isInvalid={!!(formik.touched.password && formik.errors.password)}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.password}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirm-password">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              name="confirmPassword"
              onChange={formik.handleChange}
              isInvalid={!!(formik.touched.confirmPassword && formik.errors.confirmPassword)}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.confirmPassword}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>Close</Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>Add</Button>
        </Modal.Footer>
    </Modal>
  </>);
};

export default NewUserModalForm;
